// extracted by mini-css-extract-plugin
export default {"headlineSection":"HeadlineSection_headlineSection__dVenv","Pulsate":"HeadlineSection_Pulsate__34Lpx"};